export default __webpack_public_path__ + "static/media/cross.87e86d57.svg";